import { LOGIN_ERROR } from './HomeConstants'

export function setError(code = '', extra = null) {
  return {
    type: LOGIN_ERROR,
    payload: { UserFriendlyErrorCode: code, extra },
  }
}
